import React from 'react';
import CityLandingPage from '../CityLandingPage/CityLandingPage';
import { cityContent } from '../../data/cityLandingContent';

const LandingPageAlicante = props => {
  return <CityLandingPage cityKey="Alicante" cityConfig={cityContent.alicante} {...props} />;
};

export default LandingPageAlicante;
